/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';

/**
 * 
 * @export
 * @interface ContratLieuxFormationSearchDto
 */
export interface ContratLieuxFormationSearchDto {
    /**
     * 
     * @type {number}
     * @memberof ContratLieuxFormationSearchDto
     */
    idapprenant?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ContratLieuxFormationSearchDto
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof ContratLieuxFormationSearchDto
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof ContratLieuxFormationSearchDto
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ContratLieuxFormationSearchDto
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof ContratLieuxFormationSearchDto
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof ContratLieuxFormationSearchDto
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the ContratLieuxFormationSearchDto interface.
 */
export function instanceOfContratLieuxFormationSearchDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ContratLieuxFormationSearchDtoFromJSON(json: any): ContratLieuxFormationSearchDto {
    return ContratLieuxFormationSearchDtoFromJSONTyped(json, false);
}

export function ContratLieuxFormationSearchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContratLieuxFormationSearchDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idapprenant': !exists(json, 'idapprenant') ? undefined : json['idapprenant'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function ContratLieuxFormationSearchDtoToJSON(value?: ContratLieuxFormationSearchDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idapprenant': value.idapprenant,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

